import FooterLeft from "../../assets/svg/FooterLeft";
import FooterRight from "../../assets/svg/FooterRight";
import {
  Box,
  Container,
  Heading,
  Text,
  ListWrapper,
  MainText,
  Solutions,
  LeftWrapper,
  RightWrapper,
  List,
  Info,
  InfoText,
  InfoTextB,
} from "../../styles/components/Footer";

const Footer = ({ refs, handleLinkClick }: any) => {
  return (
    <>
      <Container>
        <LeftWrapper>
          <FooterLeft />
        </LeftWrapper>
        <Box>
          <MainText className="stardos-stencil-bold">
            We are recruitment agency that help you find more talents to develop business
          </MainText>
          <Solutions>
            <ListWrapper>
              <Heading>Solution</Heading>
              <List>
                <Text onClick={() => handleLinkClick("about")}>About us</Text>
                <Text onClick={() => handleLinkClick("services")}>Services</Text>
                <Text onClick={() => handleLinkClick("caseStudies")}>How We Work</Text>
                <Text onClick={() => handleLinkClick("blog")}>Blog</Text>
                <Text onClick={() => handleLinkClick("contactUs")}>Contact Us</Text>
              </List>
            </ListWrapper>
          </Solutions>
        </Box>
        <RightWrapper>
          <FooterRight />
        </RightWrapper>
      </Container>
      <Info>
        <InfoText>Copyright © 2024 Hire Hub Solutions. All right reserved.</InfoText>
        <InfoTextB>info@hirehubz.com</InfoTextB>
      </Info>
    </>
  );
};

export default Footer;
